<template>
    <div class="content-header border-bottom">
        <div v-if="currentCustomer != 0">
            <a class="btn btn-sm btn-alt-info me-1  pb-1" :href="routeCustomerFile" target="_blank">
                <img
                    v-if="currentCustomer.image"
                    class="img-avatar img-avatar48"
                    style="width: 34px; height: 34px"
                    :src="currentCustomer.image"
                    alt=""
                />
                <span v-else class="material-icons-outlined text-info" title="Fiche client">
                    person
                </span>
            </a>
            <span class="text-dark fw-semibold fs-sm" href="javascript:void(0)"
                >{{ currentCustomer.first_name }} {{ currentCustomer.last_name }}</span
            >
        </div>
        <div>
            <!-- <button class="btn btn-sm btn-alt-success">Offrir<i class="fa fa-fw fa-gift"></i></button> -->
            <!-- <button
                role="button"
                type="button"
                class="ms-auto btn btn-sm btn-alt-info"
                data-bs-toggle="modal"
                data-bs-target="#modal-custom-discount"
            >
                Remise personnalisée
            </button> -->
            <button
                role="button"
                v-if="currentCustomer"
                type="button"
                class="ms-auto btn btn-sm btn-alt-primary "
                @click="
                    () => {
                        $emit('show-iframe', currentCustomer.id)
                    }
                "
            >
                Ajouter carte compte client
                <v-icon size="20px">mdi-credit-card-outline</v-icon>
            </button>
            <a
                class="ms-auto btn btn-sm"
                href="javascript:void(0)"
                data-toggle="layout"
                data-action="side_overlay_close"
            >
                <i class="fa fa-fw fa-times"></i>
            </a>
        </div>
    </div>
</template>

<script>
import { get } from 'vuex-pathify'

export default {
    props: ['currentCustomer', 'routeCustomerFile'],

    computed: {
        ...get('overlay@data', {
            c_customDiscount: 'customDiscount',
        }),
    },
}
</script>
